/**
 * @generated SignedSource<<5bca132a7272143758f86403d670232d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "arrangementId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationCityId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSameDay"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "journeyDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeTimeId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceCityId"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "arrangementId",
        "variableName": "arrangementId"
      },
      {
        "kind": "Variable",
        "name": "destinationCityId",
        "variableName": "destinationCityId"
      },
      {
        "kind": "Variable",
        "name": "isSameDay",
        "variableName": "isSameDay"
      },
      {
        "kind": "Variable",
        "name": "journeyDate",
        "variableName": "journeyDate"
      },
      {
        "kind": "Variable",
        "name": "routeId",
        "variableName": "routeId"
      },
      {
        "kind": "Variable",
        "name": "routeTimeId",
        "variableName": "routeTimeId"
      },
      {
        "kind": "Variable",
        "name": "sourceCityId",
        "variableName": "sourceCityId"
      }
    ],
    "concreteType": "CompanyCancellationResponseType",
    "kind": "LinkedField",
    "name": "cancellationPolicyBasedOnRoute",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fromMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deductPercentage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundPercentage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "remarks",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CancellationPolicyBasedOnRouteQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CancellationPolicyBasedOnRouteQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "ca8720908bc08c5026072c5c4a267700",
    "id": null,
    "metadata": {},
    "name": "CancellationPolicyBasedOnRouteQuery",
    "operationKind": "query",
    "text": "query CancellationPolicyBasedOnRouteQuery(\n  $journeyDate: String\n  $sourceCityId: Int\n  $destinationCityId: Int\n  $routeId: Int\n  $routeTimeId: Int\n  $arrangementId: Int\n  $isSameDay: String\n) {\n  cancellationPolicyBasedOnRoute(journeyDate: $journeyDate, sourceCityId: $sourceCityId, destinationCityId: $destinationCityId, routeId: $routeId, routeTimeId: $routeTimeId, arrangementId: $arrangementId, isSameDay: $isSameDay) {\n    fromMinutes\n    toMinutes\n    deductPercentage\n    refundPercentage\n    createdDate\n    updatedDate\n    remarks\n  }\n}\n"
  }
};
})();

node.hash = "f99210f9c909af429db9b261cd88bcec";

module.exports = node;
